module.exports = __webpack_public_path__ + "img/map_c.d871d5f0.svg";